import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router';
import { useFlags } from 'src/feature-flags/FlagsHook';
import { ory } from 'src/auth/ory';
import PageLoader from 'src/UI/loader/PageLoader';
import { GenericErrorPage } from 'src/error/GenericErrorPage';
import { LoginPage } from 'src/auth/login/LoginPage';
import { useIsMobile } from 'src/common/hooks/useIsMobile';

export const LoginPageWithFlag = () => {
  const { flagEnabledCustomSettingsFlow } = useFlags();
  const { isMobile } = useIsMobile();
  const [searchParams] = useSearchParams();
  const flowId = searchParams.get('flow');

  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (flagEnabledCustomSettingsFlow === false && !flowId) {
      ory
        .createBrowserLoginFlow({ refresh: true })
        .then(({ data }) => {
          window.location.replace(data.request_url);
        })
        .catch(() => setIsError(true));
    }
  }, [flagEnabledCustomSettingsFlow, flowId]);

  if (isMobile === undefined) {
    return <PageLoader />;
  }

  if (flagEnabledCustomSettingsFlow) {
    return <LoginPage />;
  }

  return isError ? (
    <GenericErrorPage error={new Error('Failed creating browser login flow')} />
  ) : (
    <PageLoader />
  );
};
